import { SetIsUnAssigned } from './../../../../presentation/locations/state/locations.actions';
import { BaseDataGridRequest } from "../base-data-grid.request";

export interface GetLocationsRequest extends BaseDataGridRequest {
  id?: string;
  locationId?: string;
  locationName?: string;
  latitude?: number;
  longitude?: number;
  address?: string;
  template?:string;
  postalCode?: string;
  city?: string;
  country?: string;
  stopTime?: string;
  serviceTime?: string;
  pickupCapacityType1?: number;
  pickupCapacityType2?: number;
  pickupCapacityType3?: number;
  deliveryCapacityType1?: number;
  deliveryCapacityType2?: number;
  deliveryCapacityType3?: number;
  planId?: string;
  jobId?: string;
  precedence?: number;
  planName?: string;
  jobName?: string;
  createdAt?: Date;
  isUnAssigned?:boolean
}
